"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef } from "react";
export default function Introduction() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const animationFrameRef = useRef<number | null>(null);
  const offsetRef = useRef(0);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);
    const drawTree = () => {
      if (!ctx || canvas.width === 0 || canvas.height === 0) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const treeX = (canvas.width / 2 + offsetRef.current) % (canvas.width + 200) - 100;
      const treeY = canvas.height / 2;
      ctx.save();
      ctx.globalAlpha = 0.05;
      ctx.strokeStyle = "hsl(75, 35%, 35%)";
      ctx.lineWidth = 3;
      const drawBranch = (x: number, y: number, length: number, angle: number, depth: number) => {
        if (depth === 0) return;
        const endX = x + Math.cos(angle) * length;
        const endY = y + Math.sin(angle) * length;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(endX, endY);
        ctx.stroke();
        drawBranch(endX, endY, length * 0.7, angle - 0.4, depth - 1);
        drawBranch(endX, endY, length * 0.7, angle + 0.4, depth - 1);
      };
      drawBranch(treeX, treeY, 60, -Math.PI / 2, 5);
      ctx.restore();
    };
    const animate = () => {
      offsetRef.current += 0.3;
      drawTree();
      animationFrameRef.current = requestAnimationFrame(animate);
    };
    animate();
    return () => {
      window.removeEventListener("resize", resize);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);
  return <section className="relative w-full min-h-screen bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/image_tu04b8yj.png)] overflow-hidden flex items-center justify-center px-6 py-16">
      {}
      <div className="absolute inset-0 bg-primary/70 z-[1]" />

      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full pointer-events-none" style={{
      zIndex: 2
    }} />

      <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6">
        <h1 ref={headlineRef} className={`font-display text-5xl md:text-6xl font-bold text-white transition-all duration-700 ease-smooth ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Welcome to our Services
        </h1>

        <p ref={paragraphRef} className={`font-sans text-lg md:text-xl text-white/90 max-w-2xl mx-auto transition-all duration-[200ms] ease-out ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>At Education Family Tutors, we provide <strong data-ast-id="f:/src/pages/PremiumServices/sections/Introduction.tsx|sig:w9sry9" data-ast-start="3267" data-ast-end="3433">structured academic support</strong> designed to help students build strong subject knowledge, develop confidence, and perform consistently under pressure.<br /><br />Our services go beyond traditional tutoring. We combine <strong data-ast-id="f:/src/pages/PremiumServices/sections/Introduction.tsx|sig:w7oapr" data-ast-start="3620" data-ast-end="3780">high-quality teaching</strong>, <strong data-ast-id="f:/src/pages/PremiumServices/sections/Introduction.tsx|sig:w70mpt" data-ast-start="3782" data-ast-end="3938">academic coaching</strong>, and <strong data-ast-id="f:/src/pages/PremiumServices/sections/Introduction.tsx|sig:w5zjzs" data-ast-start="3944" data-ast-end="4104">modern learning tools</strong> to support students both academically and personally.<br /><br />Here you can explore our <b>tutoring </b>and <b>academic coaching</b> services, <b>how our approach works</b>, and the <b contenteditable="false" style={{}}>programmes </b>available to support long-term progress.<br /></p>
      </div>
    </section>;
}